import * as React from 'react';
import {useSelector} from 'react-redux';

import {Card} from 'shells/card/card';
import {Metric} from 'shells/metrics/metric';
import type {MetricType} from 'shells/metrics/metric';
import {Body} from 'shells/typography/body';

import * as reportSelectors from '../../../reports/reports-selectors';

import type {NutshellState} from '../../../../store';

import styles from './sales-document-graph-card.module.css';

type Props = {
    chart: React.ReactNode;
    salesDocumentType: 'quote' | 'invoice';
};

export function SalesDocumentGraphCard(props: Props) {
    const quotesStats = useSelector((state: NutshellState) =>
        reportSelectors.getSummaryStatsStats(state)
    );
    const isStatsLoading = useSelector((state: NutshellState) =>
        reportSelectors.getSummaryStatsIsLoading(state)
    );

    // @ts-expect-error
    const stats: MetricType &
        {
            key: string;
        }[] = React.useMemo(() => {
        const areStatsLoaded =
            quotesStats &&
            quotesStats.open &&
            quotesStats.open.total &&
            quotesStats.overdue &&
            quotesStats.overdue.total;

        return [
            {
                key: 'open',
                title:
                    props.salesDocumentType === 'quote'
                        ? 'Current open quotes'
                        : 'Current open invoices',
                value: areStatsLoaded ? quotesStats.open.count.value : null,
                isLoading: isStatsLoading,
                bottomRow: (
                    <Body size='small' color='medium'>
                        {areStatsLoaded ? quotesStats.open.total.prefix : null}
                        {areStatsLoaded ? quotesStats.open.total.formatted : null}
                        {areStatsLoaded ? quotesStats.open.total.suffix : null}
                        {' in revenue'}
                    </Body>
                ),
            },
            {
                key: 'overdue',
                title:
                    props.salesDocumentType === 'quote'
                        ? 'Current overdue quotes'
                        : 'Current overdue invoices',
                value: areStatsLoaded ? quotesStats.overdue.count.value : null,
                isLoading: isStatsLoading,
                bottomRow: (
                    <Body size='small' color='error'>
                        {areStatsLoaded ? quotesStats.overdue.total.prefix : null}
                        {areStatsLoaded ? quotesStats.overdue.total.formatted : null}
                        {areStatsLoaded ? quotesStats.overdue.total.suffix : null}
                        {' in revenue'}
                    </Body>
                ),
            },
        ];
    }, [isStatsLoading, props.salesDocumentType, quotesStats]);

    return (
        <div className='pad-16'>
            <Card hasBorder={true} fitHeight={false} fitContent={false}>
                <div className='flex'>
                    <div className={styles['stats-container']}>
                        {stats.map((stat) => {
                            return (
                                <React.Fragment key={stat.key}>
                                    {/* @ts-expect-error */}
                                    <Metric {...stat} size='normal' isLoading={isStatsLoading} />
                                </React.Fragment>
                            );
                        })}
                    </div>
                    <div className='full-width mr-16'>{props.chart}</div>
                </div>
            </Card>
        </div>
    );
}
